import { gql } from "@apollo/client";export default gql`mutation updateUser($id: Int!, $name: String = "", $email: String = "", $role: String = "") {
  updateUser: update_user_by_pk(pk_columns: { id: $id }, _set: { email: $email, name: $name, role: $role }) {
    id
    name
    role
    email
  }
}
`;
